export default "__VITE_ASSET__DNPF1pH6__"